import React from 'react'
import { Box } from '@mui/material'

/** Preview image for EVSE for evse pairing dialogs*/
export const EvsePreviewImage: React.FC<{
  reference: string
  width: number
  height: number
}> = ({ reference, width, height }) => {
  return (
    <Box
      component="img"
      loading="lazy"
      src={reference}
      width={width}
      height={height}
      sx={{
        ml: { xs: 'auto', sm: -2, md: 2 },
        mr: { xs: 'auto', sm: 2, md: 6 },
      }}
    />
  )
}
